import css from 'styled-jsx/css';
import { phone, tablet_desktop } from '../../../../styles/media';
import typography from '../../../../styles/typography';

export const styles = css`
    .BigProductCardDescription__content {
      align-self: flex-start;
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
    .BigProductCardDescription__section {
      width: calc(50% - 15px);
      margin-bottom: 30px;
    }
    .BigProductCardDescription__heading {
      ${typography.h4}
      margin-bottom: 20px;
      line-height: 19px;
    }
    .BigProductCardDescription__text {
      ${typography.text}
      color: var(--colors-text);
    }
    .BigProductCardDescription__factsList {
      list-style: none;
      display: flex;
      flex-direction: column;
    }
    .BigProductCardDescription__infoEntry {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 15px;
    }
    .BigProductCardDescription__infoEntry:last-child {
      margin-bottom: 0;
    }
    .BigProductCardDescription__entryTitle {
      margin-right: 30px;
    }
    .BigProductCardDescription__entryValue {
      text-align: right;
    }
    .BigProductCardDescription__link {
      color: var(--uiColors-BigProductCard-linkColor);
    }

    @media ${tablet_desktop} {
      .BigProductCardDescription__section:nth-child(odd) {
        margin-right: 30px;
      }
    }

    @media ${phone} {
      .BigProductCardDescription__section {
        width: 100%;
      }
    }
  `;
